// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mqS-W","footer":"styles_footer__NY8u-"};